function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { Label, Stack, Text, Icon, Toggle, Link } from '@fluentui/react';
import Tooltip from '@shared/components/tooltip';
export var RecurringBillingValues = /*#__PURE__*/ function(RecurringBillingValues) {
    RecurringBillingValues["On"] = "On";
    RecurringBillingValues["Off"] = "Off";
    return RecurringBillingValues;
}({});
const DEFAULT_RECURRING_VALUE = 'When auto-renew is turned off, the subscription will terminate at the end of billing term. When turned on, the subscription will renew to a valid private or public price.';
const DEFAULT_LEARN_MORE_LINK = 'https://learn.microsoft.com/en-us/marketplace/private-offers-purchase';
const DEFAULT_LEARN_MORE_TEXT = 'Learn more';
export class RecurringOption extends SpzaComponent {
    renderImpl() {
        const { recurringBilling, showAutoRenewMessage } = this.props.checkout.items[0];
        const calloutProps = {
            gapSpace: 0
        };
        const labelId = 'labelElement';
        const infoBalloonLabelId = 'InfoBalloon';
        const tooltipId = 'tooltipElement';
        const autoRenewTextAndLinkContent = /*#__PURE__*/ _jsxs(Text, {
            className: "ms-font-s",
            children: [
                this.context.loc('Checkout_PriceAndBilling_RecurringInfoBalloon', DEFAULT_RECURRING_VALUE),
                " ",
                /*#__PURE__*/ _jsx(Link, {
                    className: "ms-font-s",
                    href: DEFAULT_LEARN_MORE_LINK,
                    target: "_blank",
                    "aria-labelledby": labelId,
                    children: this.context.loc('Checkout_Button_LearnMore', DEFAULT_LEARN_MORE_TEXT)
                })
            ]
        });
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Label, {
                    id: labelId,
                    className: "mt-20",
                    children: /*#__PURE__*/ _jsx(Stack, {
                        horizontal: true,
                        verticalAlign: "center",
                        children: /*#__PURE__*/ _jsxs(Text, {
                            className: "ms-fontWeight-semibold",
                            children: [
                                `${this.context.loc('Checkout_BillingOptions_IsRecurring', 'Auto-renew')} `,
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    tooltipHostProps: {
                                        content: autoRenewTextAndLinkContent,
                                        id: tooltipId,
                                        calloutProps
                                    },
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        iconName: "Info",
                                        id: infoBalloonLabelId,
                                        "aria-label": this.context.loc('Checkout_PriceAndBilling_RecurringInfoBalloon', DEFAULT_RECURRING_VALUE)
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    className: "requiredColor",
                                    children: ` *`
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Toggle, {
                    "data-bi-id": "isRecurring",
                    "data-bi-name": "Recurring billing component",
                    defaultChecked: recurringBilling,
                    role: "switch",
                    "aria-labelledby": labelId,
                    onText: this.context.loc('On', 'On'),
                    offText: this.context.loc('Off', 'Off'),
                    onChange: this.handleAutoRenewChange
                }),
                showAutoRenewMessage && autoRenewTextAndLinkContent
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "handleAutoRenewChange", (ev, checked)=>{
            // If recurring billing is On, set recurring to true
            this.props.setRecurringBilling({
                id: this.props.checkout.items[0].id,
                recurringBilling: checked
            });
        });
    }
}
RecurringOption.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
